import { render } from "./RekionAdminMenu.vue?vue&type=template&id=a091e904&scoped=true&ts=true"
import script from "./RekionAdminMenu.vue?vue&type=script&lang=ts"
export * from "./RekionAdminMenu.vue?vue&type=script&lang=ts"

import "./RekionAdminMenu.vue?vue&type=style&index=0&id=a091e904&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a091e904"]])

export default __exports__